var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('a',{staticClass:"button",attrs:{"href":"#","id":"btn1"}},[_c('span',{staticClass:"line line-top"}),_vm._v(" "),_c('span',{staticClass:"line line-right"}),_vm._v(" "),_c('span',{staticClass:"line line-bottom"}),_vm._v(" "),_c('span',{staticClass:"line line-left"}),_vm._v("\n    "+_vm._s(_vm.btn1Msg)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a2417e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/button/btn1/btn1.vue
// module id = 24
// module chunks = 0